import { isProd } from "config";
import { ICreateSiwe } from "interfaces";
import { SiweMessage } from "siwe";
import { randomNumber } from "./showFirstLastAddress";

export const createSiweMessage = ({ address, statement }: ICreateSiwe) => {
  const domain = window.location.host;
  const origin = window.location.origin;

  let chainId = isProd ? 42220 : 44787;
  const expirationTime = "14040";
  const siweMessage = new SiweMessage({
    domain,
    address,
    statement,
    nonce: String(randomNumber()),

    expirationTime,
    uri: origin,
    version: "1",
    chainId,
  });

  return siweMessage.prepareMessage();
};
